export const CLINIC_NAME = "Mutha's Advanced Dental Care";
export const CLINIC_SHORT = "Mutha's Advanced Dental Care";
export const DOCTOR_NAME = "Dr. Khushboo Mutha";
export const DOCTOR_TITLE = "Dental Surgeon — Implantology, Prosthodontics & Smile Design";
export const DOCTOR_CREDENTIALS = "BDS, MDS (Prosthodontics) · 15+ Years · 10,000+ Smiles in Kalyan";
export const PHONE_PRIMARY = "+91 93233 66660";
export const PHONE_WHATSAPP = "+91 93233 66660";
export const WHATSAPP_NUMBER = "919323366660";
export const PHONE_PRIMARY_TEL = "tel:+919323366660";
export const EMAIL = "info@muthadentalcare.com";
export const INSTAGRAM = "@drkhushbumutha";
export const INSTAGRAM_URL = "https://www.instagram.com/drkhushbumutha";
export const GOOGLE_MAPS_EMBED = "https://www.google.com/maps?q=19.24163233108657,73.13648224536787&hl=en&z=18&output=embed";
export const GOOGLE_MAPS_DIRECTIONS = "https://maps.app.goo.gl/iNMqy1fsc3FwCWtv7";
export const CLINIC_ADDRESS = "Mutha's Advanced Dental Care, Rambaug, Kalyan, Maharashtra, India";
export const CLINIC_TIMINGS = {
  weekdays: "10:00 AM – 2:00 PM, 5:00 PM – 9:00 PM",
  sunday: "10:00 AM – 2:00 PM",
  closed: "Thursday",
};

/** Treatment options used by every booking form on the site. */
export const TREATMENT_OPTIONS = [
  "Tooth Pain / Root Canal",
  "Dental Implants / Missing Teeth",
  "Braces / Invisalign / Aligners",
  "Smile Makeover / Veneers",
  "Teeth Whitening",
  "Child Dentistry",
  "Teeth Cleaning / Check-up",
  "Emergency Dental Care",
  "Other",
];

export const PREFERRED_TIME_OPTIONS = ["Morning", "Afternoon", "Evening"];

export const PRIVACY_LINE =
  "Your details will only be used to contact you about your appointment.";

export const CONSENT_TEXT = "I agree to be contacted regarding my appointment.";

export const WHATSAPP_BOOKING_INTRO =
  "Hello Mutha's Advanced Dental Care. I would like to book a dental consultation. My concern is:";


export const getWhatsAppUrl = (message?: string) => {
  const msg = encodeURIComponent(message || "Hi, I'd like to book an appointment at Mutha's Advanced Dental Care.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
};

export const SERVICES_NAV = [
  { name: "Dental Implants", slug: "dental-implants" },
  { name: "Full Mouth Implants", slug: "full-mouth-implants" },
  { name: "Root Canal Treatment", slug: "root-canal-treatment" },
  { name: "Invisible Aligners", slug: "invisible-aligners" },
  { name: "Braces Treatment", slug: "braces-treatment" },
  { name: "Teeth Whitening", slug: "teeth-whitening" },
  { name: "Smile Makeover", slug: "smile-makeover" },
  { name: "Pediatric Dentistry", slug: "pediatric-dentistry" },
  { name: "Gum Treatment", slug: "gum-treatment" },
  { name: "Tooth Extraction", slug: "tooth-extraction" },
  { name: "Crowns & Bridges", slug: "crowns-and-bridges" },
  { name: "Cosmetic Fillings", slug: "cosmetic-fillings" },
  { name: "Overlays & Inlays", slug: "overlays-inlays" },
  { name: "Scaling & Cleaning", slug: "scaling-cleaning" },
];
